
import React, { FunctionComponent } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'
import { formatMessageSafe } from '../../../util/translateInputOptions'

interface Props {
  error?: any
}

const messages = defineMessages({
  error: {
    id: 'containers.graphql.error',
    defaultMessage: 'Unexpected error occured',
  },
})

const Error: FunctionComponent<Props> = ({ error }) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  const message = error && typeof error === 'string' ? error : formatMessage(messages.error)
  return (
    <Container>
      <ErrorMessage>{message}</ErrorMessage>
    </Container>
  )
}

export const Container = styled.div`
  padding: 3em;
  background-color: ${props => props.theme.colors.red100};
`

export const ErrorMessage = styled.div`
  text-align: center;
  color: ${props => props.theme.colors.red900};
  font-size: 2em;
`

export default Error
